import base from "../baseurl";
import token from "../getTk";

const showAll = async () => {
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });

  //console.log("el token ", tokenA)
  const CompaniesShow = await api
    .get("companies/index", {
      timeout: false,
    })
    .json();
  console.log(CompaniesShow);
  return CompaniesShow.data.companies;
};

export default showAll;
